import * as React from 'react'
import * as Styles from './styles'

interface Props {
  children: any
}

interface State {
  isVisible: boolean
}

const DELAY_TILL_SHOW = 3000

export default class Prompt extends React.Component<Props, State> {
  private lastShown: number

  constructor(props: Props) {
    super(props)

    this.state = { isVisible: false }
    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
    this.optionallyShow = this.optionallyShow.bind(this)
  }

  componentDidMount() {
    this.show()
    window.addEventListener('keydown', this.hide)
    window.setInterval(this.optionallyShow, 3000)
  }

  render() {
    const { children } = this.props
    return (
      <Styles.Prompt isVisible={this.state.isVisible}>{children}</Styles.Prompt>
    )
  }

  private hide(): void {
    this.setState({ isVisible: false })
  }

  private show(): void {
    this.setState({ isVisible: true })
    this.lastShown = new Date().getTime()
  }

  private optionallyShow(): void {
    if (new Date().getTime() - this.lastShown > DELAY_TILL_SHOW) {
      this.show()
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Prompt.tsx